import React from 'react';

/**
 * 웹소켓 사용 못해서 임시로 사용
 */
class ChangingProgressProvider extends React.Component {
  static defaultProps = {
    interval: 1000,
  };

  state = {
    valuesIndex: 0,
  };

  componentDidMount() {
    setInterval(() => {
      if (this.props.values.length > this.state.valuesIndex + 1) {
        this.setState({
          valuesIndex: this.state.valuesIndex + 1,
        });
      }
    }, this.props.interval);
  }

  render() {
    return this.props.children(this.props.values[this.state.valuesIndex]);
  }
}

export default ChangingProgressProvider;
